import axios from 'axios';
import { rodac_api, api } from '../../../env';

/* Catálogo de autos — EXTRAÍDO (copia aislada) de la lógica del cotizador
   (Views/Cotizador/functions/rodac.js + useCarCalculator). NO importa ni toca
   esos archivos, así que la calculadora NO se ve afectada.

   Cascada (igual que el cotizador):
     Condición → Tipo de vehículo → Modelo(=AÑO) → Marca → Tipo → Versión
   Condición, Tipo de vehículo y compensación son listas HARDCODED en el
   cotizador (no hay fetch); solo Modelos/Marcas/Tipos/Versiones pegan a rodac. */

// Hardcoded en el cotizador (getCarStatuses / getCarTypes).
export const CONDICIONES = [
  { id: 1, status: 'NUEVO' },
  { id: 2, status: 'SEMINUEVO' },
];

export const TIPOS_VEHICULO = [
  { id: 1, type: 'AUTO' },
  { id: 2, type: 'PICKUP' },
];

// Lista simple de motor (el cotizador no la trae de rodac; útil para placas/seguros).
export const TIPOS_MOTOR = ['Gasolina', 'Diésel', 'Híbrido', 'Eléctrico'];

const FORM = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };

async function rodacPost(path, body) {
  const res = await axios.post(`${rodac_api}/${path}`, body, FORM);
  const data = res?.data?.Data;
  if (!data || data.HasError) return [];
  return data.Data || [];
}

// ConsultaModelos: por condición. OJO: "Modelo" en rodac = AÑO del vehículo.
export async function consultaModelos(carStatusId) {
  const rows = await rodacPost('Autos/ConsultaModelos', { IdSubcanal: 20, IDEstatusVehiculo: carStatusId });
  return rows.map((i) => ({ id: i.Id, model: i.Valor }));
}

// ConsultaMarcas: por tipo de vehículo + modelo(año).
export async function consultaMarcas(carTypeId, modelId) {
  const rows = await rodacPost('Autos/ConsultaMarcas', { IDTipoVehiculo: carTypeId, modelo: modelId });
  return rows.map((i) => ({ id: i.Id, brand: i.Valor, brand_id: i.IdMarca }));
}

// ConsultaTipos: por tipo + modelo + submarca(brand).
export async function consultaTipos(carTypeId, modelId, brand) {
  const rows = await rodacPost('Autos/ConsultaTipos', { IDTipoVehiculo: carTypeId, modelo: modelId, submarca: brand });
  return rows.map((i) => ({ id: i.Id, type: i.Valor }));
}

// ConsultaDescripciones: la VERSIÓN del vehículo.
export async function consultaDescripciones(carTypeId, modelId, brand, tipo) {
  const rows = await rodacPost('Autos/ConsultaDescripciones', { IDTipoVehiculo: carTypeId, modelo: modelId, submarca: brand, tipo });
  return rows.map((i) => ({ id: i.Id, description: i.Valor }));
}

// Catálogo LOCAL (Laravel): régimen, estados (placa), valores residuales, enganche.
export async function getStaticData() {
  const res = await axios.get(`${api}/getStaticData`);
  return {
    regimes: res?.data?.regimes || [],
    residualValue: res?.data?.residualValue || [],
    state: res?.data?.state || [],
    downPayment: res?.data?.downPayment || null,
  };
}
